import React from 'react';
import { Input, Select } from 'formik-antd';
import { Divider, Typography } from 'antd';
import FormControl from '~/components/Form/FormControl';
import Box from '~/components/Box';
import Row from '~/components/Row';

export default function PropertyTab({ t, values, errors, touched, countries }) {
  const { Option } = Select;
  const { Text } = Typography;
  return (
    <Box>
      <Row> 
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="property.name"
          error={(touched.property?.name && errors.property?.name) || errors.property?.name}
          label={t('screens:bids.data.name')}
          required
        >
          <Input name="property.name" autoComplete="off" />
        </FormControl>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="property.phone"
          error={(touched.property?.phone && errors.property?.phone) || errors.property?.phone}
          label={t('screens:bids.data.phoneNumber')}
        >
          <Input name="property.phone" autoComplete="off" maxLength={27} />
        </FormControl>
        <FormControl
          cols={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
          field="property.website"
          error={(touched.property?.website && errors.property?.website) || errors.property?.website}
          label={t('screens:bids.data.website')}
        >
          <Input name="property.website" autoComplete="off" />
        </FormControl>
      </Row>
      <Divider orientation="left" orientationMargin="0">
        <Text>{t('screens:bids.data.address')}</Text>
      </Divider>
      <Row>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.property?.address?.addressLineOne && errors.property?.address?.addressLineOne}
          field="property.address.addressLineOne"
          label={t('screens:addresses.data.addressLineOne')}
          required
        >
          <Input name="property.address.addressLineOne" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 24 }}
          error={touched.property?.address?.addressLineTwo && errors.property?.address?.addressLineTwo}
          field="property.address.addressLineTwo"
          label={t('screens:addresses.data.addressLineTwo')}
        >
          <Input name="property.address.addressLineTwo" autoComplete="off" maxLength={40} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.property?.address?.city && errors.property?.address?.city}
          field="property.address.city"
          label={t('screens:addresses.data.city')}
          required
        >
          <Input name="property.address.city" autoComplete="off" maxLength={16} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.property?.address?.state && errors.property?.address?.state}
          field="property.address.state"
          label={t('screens:addresses.data.state')}
          required
        >
          <Input name="property.address.state" autoComplete="off" maxLength={21} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          field="property.address.zipCode"
          label={t('screens:addresses.data.zipCode')}
          error={touched.property?.address?.zipCode && errors.property?.address?.zipCode}
          required
        >
          <Input name="property.address.zipCode" autoComplete="off" maxLength={13} />
        </FormControl>
        <FormControl
          cols={{ xs: 12 }}
          error={touched.property?.address?.country && errors.property?.address?.country}
          field="property.address.country"
          label={t('screens:addresses.data.country')}
          required
        >
          <Select name="property.address.country" placeholder="Select">
            {countries.map(item => {
              return (
                <Option key={item.name} value={item.name}>
                  {item.description}
                </Option>
              );
            })}
          </Select>
        </FormControl>
        <FormControl
          cols={{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }}
          field="property.address.note"
          error={(touched.note && errors.note) || errors.note}
          label={t('screens:addresses.data.note')}
        >
          <Input name="property.address.note" autoComplete="off" maxLength={41} />
        </FormControl>
      </Row>
    </Box>
  );
}
